import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import ItemsCarousel from 'react-items-carousel';

const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class SucursalPage extends Component {
  constructor(props) {
    super(props);
    this.__getProgreso = this.__getProgreso.bind(this)
    this.state = {
      __getProgreso: this.__getProgreso,
      isLoading: true,
      first: true,
      arrHistorialVentas: {list: [], total: 0},
      arrHistorialCortes: {list: [], total: 0},
      arrAlmacen: [],
      arrCajeros: [],
      arrHistorialGastosFijos: {list: [], total: 0,},
      activeItemIndex: 0,
      optViewInfo: 1,
    }
  }

  __getProgreso() {
    this.goToGeneral()
  }

  componentDidMount() {
    this.goToGeneral()
    this.props.onRef(this)
  }

  render() {
    const { arrHistorialVentas, arrHistorialCortes, isLoading, optViewInfo, arrHistorialGastosFijos, arrAlmacen, } = this.state
    const { arrSucursalSelected } = this.props.initState

    if(isLoading) {
      return (
        <div className="directorPage__wrapper" style={{ marginTop: 150, }}>
          {/*<Lottie
            direction={1}
            options={{
              animationData: animationData,
              loop: true,
            }}
            />*/}
        </div>
      )
    }

    return (
      <Container className="directorPage__wrapper"  style={{ paddingTop: 20, }}>
        {/* Principal Container */}
        <>
          
          <p className="regVentaPage__productGeneral" style={{ padding: 0, margin: 0, }}>Resumen de ventas y movimientos</p>
          <Row>
            <Col xs={8}>
              <input type={"date"}
                value={this.props.initState.dateDire}
                onChange={(event) => {this.props.initsetState({dateDire: event.target.value}) }}
                style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: '7px 0px', marginBottom: '14px', width: '100%', }}
              />
            </Col>
            <Col>
              <p className={'btn btn-primary'} onClick={() => { this.goToGeneral() }}>Generar</p>
            </Col>
          </Row>


          <p className={'initialPage__separatorTitle'}>SUCURSAL: { arrSucursalSelected.t.nombre }</p>
          <Row>
            <Col style={{ textAlign: 'center', marginTop: 5, }}>
              <p style={{ fontWeight: '800', margin: 0, fontSize: '1.3rem', }}>${ this.number_format(arrHistorialVentas.total, 2) }</p>
              <p style={{ color: '#777', }}>Total cobrado</p>
            </Col>
            <Col style={{ textAlign: 'center', marginTop: 5, }}>
              <p style={{ fontWeight: '800', margin: 0, fontSize: '1.3rem', }}>${ this.number_format(arrHistorialCortes.total, 2) }</p>
              <p style={{ color: '#777', }}>Egresos</p>
            </Col>
          </Row>

          <Row>
            <Col>

              <Row>
                <Col>
                  <p
                    style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: optViewInfo === 1 ? '#2980b9' : 'transparent', border: optViewInfo === 1 ? '0px' : '1px solid #2980b9', color: optViewInfo === 1 ? '#fff' : '#2980b9', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0', }}
                    onClick={ () => { this.setState({ optViewInfo: 1, }, this.goToGeneral); }} className="regVentaPage__title">Detalles de vendedores</p>
                </Col>
                <Col>
                  <p
                    style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: optViewInfo === 2 ? '#2980b9' : 'transparent', border: optViewInfo === 2 ? '0px' : '1px solid #2980b9', color: optViewInfo === 2 ? '#fff' : '#2980b9', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0', }}
                    // onClick={ () => { this.setState({ optViewInfo: 2, }, this.goToGeneral); }} className="regVentaPage__title">Venta por categoría</p>
                    onClick={ () => { alert('Módulo en desarrollo') }} className="regVentaPage__title">Venta por categoría</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p
                    style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: optViewInfo === 3 ? '#2980b9' : 'transparent', border: optViewInfo === 3 ? '0px' : '1px solid #2980b9', color: optViewInfo === 3 ? '#fff' : '#2980b9', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0', }}
                    onClick={ () => { this.setState({ optViewInfo: 3, }, this.goToGeneral); }} className="regVentaPage__title">Gastos por turno</p>
                </Col>
                <Col>
                  <p
                    style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: optViewInfo === 4 ? '#2980b9' : 'transparent', border: optViewInfo === 4 ? '0px' : '1px solid #2980b9', color: optViewInfo === 4 ? '#fff' : '#2980b9', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0', }}
                    onClick={ () => { this.setState({ optViewInfo: 4, }, this.goToGeneral); }} className="regVentaPage__title">Gastos fijos</p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p
                    style={{ padding: '5px 14px', marginTop: 10, cursor: 'pointer', textAlign: 'center', background: optViewInfo === 5 ? '#2980b9' : 'transparent', border: optViewInfo === 5 ? '0px' : '1px solid #2980b9', color: optViewInfo === 5 ? '#fff' : '#2980b9', borderRadius: '4px', fontWeight: 600, width: '100%', margin: '4px 0', }}
                    onClick={ () => { this.setState({ optViewInfo: 5, }, this.goToGeneral); }} className="regVentaPage__title">Información de almacen</p>
                </Col>
              </Row>

            </Col>
          </Row>

          <hr />

          {
            optViewInfo == 1 ? (
              <>
                <p>Detalles de vendedores</p>
                <ItemsCarousel
                  enablePlaceholder={false}
                  numberOfPlaceholderItems={1}
                  minimumPlaceholderTime={1000}
                  placeholderItem={<div style={{ height: 200, background: '#900' }}></div>}
                  numberOfCards={1}
                  gutter={10}
                  showSlither={true}
                  firstAndLastGutter={true}
                  freeScrolling={false}
                  requestToChangeActive={ (index) => { this.setState({ activeItemIndex: index }); } }
                  activeItemIndex={this.state.activeItemIndex}
                  activePosition={'center'}
                  chevronWidth={10}
                  rightChevron={''}
                  leftChevron={''}
                  outsideChevron={false}
                  >
                  {
                  (this.state.arrCajeros) && this.state.arrCajeros.map((t,e) => (
                    <div className={'directorPage__carousel_container'} onClick={() => {  }} key={1} style={{ background: this.getColorByIndex(e) }}>
                      { this.makeViewByItem('Num. cliente inicial', (
                        t.infoCaja.folio_start - t.infoCaja.folio_end < 1 ? 1 :
                        t.infoCaja.folio_start - t.infoCaja.folio_end
                        ), null, 0) }
                      { this.makeViewByItem('Num. cliente final', (t.infoCaja.folio_end), null, 0) }
                      { this.makeViewByItem('Total de clientes del día', (t.infoCaja.folio_end), null, 0) }
                      { this.makeViewByItem('Total en caja', ((t.infoCaja.efectivo + t.infoCaja.abonos + t.infoCaja.aperturas) - (t.infoCaja.parciales + t.infoCaja.proveedores)), null, 1) }
                      { this.makeViewByItem('Efectivo', t.infoCaja.efectivo, null, 1) }
                      { this.makeViewByItem('Tarjeta de crédito', t.infoCaja.credito, null, 1) }
                      { this.makeViewByItem('Tarjeta de débito', t.infoCaja.debito, null, 1) }
                      { this.makeViewByItem('Parciales', t.infoCaja.parciales, null, 1) }
                      { this.makeViewByItem('Abonos', t.infoCaja.abonos, null, 1) }
                      { this.makeViewByItem('Aperturas', t.infoCaja.aperturas, null, 1) }
                      { this.makeViewByItem('Merma', t.infoCaja.merma, null, 1) }
                      { this.makeViewByItem('Notas de crédito', t.infoCaja.nota_credito, null, 1) }
                      { this.makeViewByItem('Pago a terceros (proveedores)', t.infoCaja.proveedores, null, 1) }
                      {/*{ this.makeViewByItem('Traspasos', t.infoCaja.traspaso, null, 1) }*/}
                      { this.makeViewByItem('Total', t.infoCaja.total, null, 1) }

                      <p className={'sucursalPage__carousel_name'}>{t.nombre}</p>
                    </div>
                  ))
                  }
                </ItemsCarousel>
              </>
            ) : null
          }

          {
            optViewInfo == 3 ? (
              <>
                {
                  this.state.arrCajeros.map((t,e) => (
                    <div>
                      <b>{t.nombre}</b>

                      <p style={{ fontWeight: 600, fontSize: '1.1rem', textTransform: 'uppercase', margin: '20px 0', }}>Mis cortes de hoy</p>
                      {
                        t.cortes.list.map((t0,e0) => (
                          <Row
                            onClick={ () => {  } }
                            key={`ws_list_compra_${e0}`}
                            style={{ width: '100%', margin: '0 auto', marginTop: 10, }}
                            className="regVentaPage__content"
                          >
                            <div className="regVentaPage__separator"></div>
                            <Col className="regVentaPage__listProduct">
                              <p style={{ color: t0.status === 0 ? '#F4AA35' : '#333' }}>{t0.nombre}</p>
                              <p>{t0.hora}</p>
                              <p className="regVentaPage__productInfo" style={{ paddingBottom: '20px !important' }}>
                                {
                                  t0.status === 1
                                  ? 'El administrador aún no ha verificado este corte.'
                                  : 'Este corte ya se encuentra autorizado.'
                                }
                              </p>
                              <p className="regVentaPage__productInfo" style={{ paddingBottom: '20px !important', marginTop: 20, color: '#000', }}>{t0.observacion}</p>
                            </Col>
                            <Col className="regVentaPage__listPrices" xs={7}>
                              <p className="lprices__amount">${ this.number_format( (parseInt(t0.valor)) , 2) }</p>
                            </Col>
                          </Row>
                        ))
                      }
                      <br />
                      <hr />

                      {
                        (t.infoCaja.length > 0) && t.infoCaja.map((t0, e0) => (
                          <div>
                            {
                              t0.merma.listado.length > 0 ||
                              t0.nota_credito.listado.length > 0 ||
                              t0.traspaso.listado.length > 0 ||
                              t0.ventas.listado.length > 0 ? (
                                <>
                                  <b style={{ marginTop: 10, }}>{t0.nombre}</b>
                                  <br />
                                  { this.makeInfoCajaByType('Merma', t0.merma) }
                                  { this.makeInfoCajaByType('Nota de crédito', t0.nota_credito) }
                                  {/*{ this.makeInfoCajaByType('Traspaso', t0.traspaso) }*/}
                                  { this.makeInfoCajaByType('Ventas', t0.ventas) }
                                  <hr />
                                </>
                              ) : null
                            }
                          </div>
                        ))
                      }
                    </div>
                  ))
                }
              </>
            ) : null
          }



          {
            optViewInfo === 4 ? (
              <>

                <Row>
                  <Col>
                    <p>Nombre</p>
                  </Col>
                  <Col>
                    <p>Observación</p>
                  </Col>
                  <Col>
                    <p>Monto</p>
                  </Col>
                </Row>

                {
                  typeof arrHistorialGastosFijos.list === 'object' && arrHistorialGastosFijos.list.map((t,e) => (
                     <Row className={'ws__listNthChild'}>
                        <Col>
                          <p>{t.nombre}</p>
                        </Col>
                        <Col>
                          <p>{t.observacion}</p>
                        </Col>
                        <Col>
                          <p>${this.number_format(t.valor, 2)}</p>
                        </Col>
                      </Row>
                  ))
                }

                <b>Total: ${this.number_format(arrHistorialGastosFijos.total, 2)}</b>


              </>
              ) : null

          }

          {
            optViewInfo === 5 && typeof arrAlmacen === 'object' && arrAlmacen.map((t,e) => (
              <div
                key={`ws_cat_almacen_${e}`}
                >
                <Row
                  onClick={() => {
                    arrAlmacen[e].show = !arrAlmacen[e].show;
                    this.setState({arrAlmacen})
                  }}
                  >
                  <Col xs={8}>
                    <p>{t.nombre}</p>
                  </Col>
                  <Col>
                    <p>{`${!t.show ? 'Mostrar' : 'Ocultar'}`}</p>
                  </Col>
                </Row>
                <div>
                  {
                    arrAlmacen[e].show && arrAlmacen[e].list.length > 0 ? (
                    <Row>
                      <Col><p>Nombre</p></Col>
                      <Col><p>cantidad</p></Col>
                      <Col><p>cantidad dia</p></Col>
                      <Col><p>cantidad merma</p></Col>
                      {/*<Col><p>cantidad traspaso</p></Col>*/}
                      <Col><p>cantidad vendida</p></Col>
                      <Col><p>clave</p></Col>
                      <Col><p>disponible</p></Col>
                      <Col><p>historico</p></Col>
                    </Row>
                    ) : null
                  }
                  {
                    arrAlmacen[e].show && arrAlmacen[e].list.map((t0,e0) => (
                      <Row className={'ws__listNthChild'}>
                        <Col><p>{t0.nombre}</p></Col>
                        <Col><p>{t0.cantidad}</p></Col>
                        <Col><p>{t0.cantidad_dia}</p></Col>
                        <Col><p>{t0.cantidad_merma}</p></Col>
                        {/*<Col><p>{t0.cantidad_traspaso}</p></Col>*/}
                        <Col><p>{t0.cantidad_vendida}</p></Col>
                        <Col><p>{t0.clave}</p></Col>
                        <Col><p>{t0.disponible}</p></Col>
                        <Col><p>{t0.historico}</p></Col>
                      </Row>
                    ))
                  }
                </div>
              </div>
            ))
          }

          <hr />

        </>

      </Container>
    )
  }

  makeInfoCajaByType(title, arr) {
    if(arr.listado.length == 0)
      return null

    return (
      <div>
        <div style={{ width: '100%', }}>
          <p>{title} (${this.number_format(arr.total,2)})</p>
        </div>
        {
          arr.listado.map((t,e) => (
            <Row>
              <Row style={{ width: '100%', padding: 5, margin: 0, background: '#f3f3f3', marginTop: 10, }}>
                <Col xs={2} style={{overflow: 'hidden'}}>{t.clave}</Col>
                <Col>{t.nombre}</Col>
              </Row>
              <Row style={{ width: '100%', padding: 5, margin: 0, }}>
                <Col>KG: {this.number_format(t.venta_kg,2)}</Col>
                <Col>${this.number_format(t.venta_pesos, 2)}</Col>
              </Row>
            </Row>
          ))
        }
      </div>
    )


  }

  makeViewByItem(title, val, perc, signal) {
    return (
      <div className={'directorPage__carousel_utilidad'}>
        {
          signal == 1 ? (
            <p className={'directorPage__carousel_valNumber'}>${`${this.number_format(val, 2)}`}</p>
          ) : 
            <p className={'directorPage__carousel_valNumber'}>{`${this.number_format(val,0)}`}</p>
        }
        <p className={'directorPage__carousel_text'}>{title}</p>
        {
          perc ? (
            <div className={'directorPage__carousel_progressBar'}>
              <div style={{ background: '#2ed573', width: `${ this.number_format((perc) * 100, 2) }%` }}></div>
            </div>
          ) : null
        }
      </div>
    )
  }

  goToGeneral() {
    //Cargar información del día
    const { dateDire, arrSucursalSelected } = this.props.initState
    let data = {
      id_sucursal: arrSucursalSelected.t.id_sucursal,
      fecha_resumen_cajero: dateDire,
      opt: this.state.optViewInfo,
    }

    if(this.state.isLoading && !this.state.first)
      return false

    this.setState({ isLoading: false, first: false, })
  
    //Get resumen from server
    fetch(this.getURLByOPT('getDireResumenVentasByDay2'), this.headersPOST({...data}))
    .then(response => response.json())
    .then((response) => {
      if(this.state.optViewInfo === 1) {
        //Detalles de vendedores
        this.setState({
          isLoading: false,
          arrCajeros:         response.cajeros,
          arrHistorialVentas: {total: response.total_vendido_dia, list: []},
          arrHistorialCortes: response.cortes,
          numVentaGlobal:     this.pad(response.numVentaGlobal, 5),
        })
      } else if(this.state.optViewInfo === 2) {
        // Venta por categoría
        this.setState({
          isLoading: false,
          arrHistorialVentas: response.ventas,
          numVentaGlobal:     this.pad(response.numVentaGlobal, 5),
        })
      } else if(this.state.optViewInfo === 3) {
        // Gastos por turno
        this.setState({
          isLoading: false,
          arrHistorialCortes: response.cortes,
          arrCajeros:         response.cajeros,
          numVentaGlobal:     this.pad(response.numVentaGlobal, 5),
        })
      } else if(this.state.optViewInfo === 4) {
        // Gastos fijos
        this.setState({
          isLoading: false,
          arrHistorialGastosFijos: {list: response.gastos_fijos.list, total: response.gastos_fijos.total},
          numVentaGlobal:     this.pad(response.numVentaGlobal, 5),
        })
      } else if(this.state.optViewInfo === 5) {
        // Información de almacen [stock de almacen wuuu]
        this.setState({
          isLoading: false,
          arrAlmacen:         response.almacen,
          numVentaGlobal:     this.pad(response.numVentaGlobal, 5),
        })
      }
    })
  }

  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    if(opt === 'isOpenViewInfoCortes') {
      return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '50%',height: '70%',} };
    }

    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

 getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://diana.wsoft.com.mx/pos/nutrisadett/REST/controllers/${PHP}?opt=${opt}`
  }


}

export default withRouter(SucursalPage)